/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Unabletoloadlistingsthisappearstobeabackendauthorizationissue11Inputs */

const en_unabletoloadlistingsthisappearstobeabackendauthorizationissue11 = /** @type {(inputs: Unabletoloadlistingsthisappearstobeabackendauthorizationissue11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your places could not be loaded. You don't have permission for this right now.`)
};

const de_unabletoloadlistingsthisappearstobeabackendauthorizationissue11 = /** @type {(inputs: Unabletoloadlistingsthisappearstobeabackendauthorizationissue11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Orte konnten nicht geladen werden. Du hast dafür gerade keine Berechtigung.`)
};

/**
* | output |
* | --- |
* | "Your places could not be loaded. You don't have permission for this right now." |
*
* @param {Unabletoloadlistingsthisappearstobeabackendauthorizationissue11Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const unabletoloadlistingsthisappearstobeabackendauthorizationissue11 = /** @type {((inputs?: Unabletoloadlistingsthisappearstobeabackendauthorizationissue11Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Unabletoloadlistingsthisappearstobeabackendauthorizationissue11Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_unabletoloadlistingsthisappearstobeabackendauthorizationissue11(inputs)
	return de_unabletoloadlistingsthisappearstobeabackendauthorizationissue11(inputs)
});
export { unabletoloadlistingsthisappearstobeabackendauthorizationissue11 as "unableToLoadListingsThisAppearsToBeABackendAuthorizationIssue" }